import {Swiper, SwiperOptions} from "swiper/types";

const initSwiper = async () => {
    const sliders = document.querySelectorAll<HTMLElement>('[data-swiper]');
    if (!sliders.length) return;

    const { default: Swiper } = await import("swiper");
    const { Autoplay, Navigation, Pagination } = await import("swiper/modules");

    let currentSwiper: HTMLElement | null = null;

    const getSwiperDefinitions = (slider: HTMLElement) => {
        currentSwiper = slider;

        const swiperDefinitions: {[key: string]: SwiperOptions} = {
            'clientLogos': {
                modules: [Autoplay],
                slidesPerView: 'auto',
                spaceBetween: 80,
                loop: true,
                speed: 4000,
                autoplay: {
                    delay: 0,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                },
                allowTouchMove: false,
                freeMode: false,
                breakpoints: {
                    768: {
                        spaceBetween: 128,
                    },
                }
            },
            'clientTestimonials': {
                modules: [Navigation, Pagination],
                initialSlide: 1,
                slidesPerView: 'auto',
                spaceBetween: 16,
                centeredSlides: true,
                loop: true,
                loopAdditionalSlides: 2,
                navigation: {
                    nextEl: '.testimonials-next',
                    prevEl: '.testimonials-prev',
                },
                pagination: {
                    el: '.testimonials-pagination',
                    clickable: true,
                    bulletClass: 'inline-block w-2 h-2 rounded-full bg-dark/30 transition-all cursor-pointer',
                    bulletActiveClass: '!w-5 !bg-brand',
                },
                breakpoints: {
                    640: {
                        spaceBetween: 24,
                    },
                    1024: {
                        spaceBetween: 32,
                    },
                },
            }
        }

        return swiperDefinitions[slider.dataset.swiper] ?? {}
    }

    sliders.forEach(slider => { new Swiper(slider, getSwiperDefinitions(slider)) })
}

export default initSwiper